import ms1 from "../../assets/portfolio/masterstudio/ms1.png";
import ms2 from "../../assets/portfolio/masterstudio/ms2.png";
import ms3 from "../../assets/portfolio/masterstudio/ms3.png";
import aa1 from "../../assets/portfolio/asihangger/aa1.png";
import aa2 from "../../assets/portfolio/asihangger/aa2.png";
import aa3 from "../../assets/portfolio/asihangger/aa3.png";
import webflix1 from "../../assets/portfolio/webflix/webflix1.png";
import webflix2 from "../../assets/portfolio/webflix/webflix2.png";
import webflix3 from "../../assets/portfolio/webflix/webflix3.png";
import d2c1 from "../../assets/portfolio/d2c/d2c1.png";
import d2c2 from "../../assets/portfolio/d2c/d2c2.png";
import d2c3 from "../../assets/portfolio/d2c/d2c3.png";
import portfolio1 from "../../assets/portfolio/vue-porto/portfolio1.png";
import portfolio2 from "../../assets/portfolio/vue-porto/portfolio2.png";
import portfolio3 from "../../assets/portfolio/vue-porto/portfolio3.png";
import emet1 from "../../assets/portfolio/emet/emet1.png";
import emet2 from "../../assets/portfolio/emet/emet2.png";
import emet3 from "../../assets/portfolio/emet/emet3.png";
import KiriminAJA1 from "../../assets/portfolio/KiriminAJA/KiriminAJA1.png";
import KiriminAJA2 from "../../assets/portfolio/KiriminAJA/KiriminAJA2.png";
import KiriminAJA3 from "../../assets/portfolio/KiriminAJA/KiriminAJA3.png";
import topupgame1 from "../../assets/portfolio/topupgame/topupgame1.png";
import topupgame2 from "../../assets/portfolio/topupgame/topupgame2.png";
import topupgame3 from "../../assets/portfolio/topupgame/topupgame3.png";
import adachat1 from "../../assets/portfolio/adachat/adachat1.png";
import adachat2 from "../../assets/portfolio/adachat/adachat2.png";
import adachat3 from "../../assets/portfolio/adachat/adachat3.png";
import d2c_v2_1 from "../../assets/portfolio/d2c_v2/d2c_v2_1.png";
import d2c_v2_2 from "../../assets/portfolio/d2c_v2/d2c_v2_2.png";
import d2c_v2_3 from "../../assets/portfolio/d2c_v2/d2c_v2_3.png";
import tokoonline1 from "../../assets/portfolio/tokoonline/tokoonline1.png";
import tokoonline2 from "../../assets/portfolio/tokoonline/tokoonline2.png";
import tokoonline3 from "../../assets/portfolio/tokoonline/tokoonline3.png";
import watchme1 from "../../assets/portfolio/watchme/watchme1.png";
import watchme2 from "../../assets/portfolio/watchme/watchme2.png";
import watchme3 from "../../assets/portfolio/watchme/watchme3.png";
import kinerjadosen1 from "../../assets/portfolio/kinerjadosen/kinerjadosen1.png";
import kinerjadosen2 from "../../assets/portfolio/kinerjadosen/kinerjadosen2.png";
import kinerjadosen3 from "../../assets/portfolio/kinerjadosen/kinerjadosen3.png";
import lazcoal1 from "../../assets/portfolio/lazcoal/lazcoal1.png";
import lazcoal2 from "../../assets/portfolio/lazcoal/lazcoal2.png";
import lazcoal3 from "../../assets/portfolio/lazcoal/lazcoal3.png";
// import hefa1 from "../../assets/portfolio/hefa/hefa1.png";
// import hefa2 from "../../assets/portfolio/hefa/hefa2.png";
// import hefa3 from "../../assets/portfolio/hefa/hefa3.png";
import bumaA1 from "../../assets/portfolio/buma/bumaA1.png";
import bumaA2 from "../../assets/portfolio/buma/bumaA2.png";
import bumaA3 from "../../assets/portfolio/buma/bumaA3.png";
import bumaM1 from "../../assets/portfolio/buma/bumaM1.png";
import bumaM2 from "../../assets/portfolio/buma/bumaM2.png";
import bumaM3 from "../../assets/portfolio/buma/bumaM3.png";
import superbuma1 from "../../assets/portfolio/buma/superbuma1.png";
import superbuma2 from "../../assets/portfolio/buma/superbuma2.png";
import superbuma3 from "../../assets/portfolio/buma/superbuma3.png";
import admin1 from "../../assets/portfolio/foreman/admin1.png";
import admin2 from "../../assets/portfolio/foreman/admin2.png";
import admin3 from "../../assets/portfolio/foreman/admin3.png";
import member1 from "../../assets/portfolio/foreman/member1.png";
import member2 from "../../assets/portfolio/foreman/member2.png";
import member3 from "../../assets/portfolio/foreman/member3.png";
import hwi1 from "../../assets/portfolio/hwi/hwi1.png";
import hwi2 from "../../assets/portfolio/hwi/hwi2.jpg";
import hwi3 from "../../assets/portfolio/hwi/hwi3.jpg";
import hwi4 from "../../assets/portfolio/hwi/hwi4.jpg";
import profilhwi1 from "../../assets/portfolio/hwi/profilhwi1.png";
import profilhwi2 from "../../assets/portfolio/hwi/profilhwi2.png";
import profilhwi3 from "../../assets/portfolio/hwi/profilhwi3.png";
import omnimata1 from "../../assets/portfolio/omnimata/omnimata1.png";
import omnimata2 from "../../assets/portfolio/omnimata/omnimata2.png";
import omnimata3 from "../../assets/portfolio/omnimata/omnimata3.png";
import adago1 from "../../assets/portfolio/adago/adago1.png";
import adago2 from "../../assets/portfolio/adago/adago2.png";
import adago3 from "../../assets/portfolio/adago/adago3.png";
import momofin1 from "../../assets/portfolio/momofin/momofin1.png";
import adminPasaroa1 from "../../assets/portfolio/pasaroa/admin1.png";
import adminPasaroa2 from "../../assets/portfolio/pasaroa/admin2.png";
import adminPasaroa3 from "../../assets/portfolio/pasaroa/admin3.png";
import memberPasaroa1 from "../../assets/portfolio/pasaroa/member1.png";
import memberPasaroa2 from "../../assets/portfolio/pasaroa/member2.png";
import memberPasaroa3 from "../../assets/portfolio/pasaroa/member3.png";
import tauku1 from "../../assets/portfolio/tauku/tauku1.png";
import tauku2 from "../../assets/portfolio/tauku/tauku2.png";
import tauku3 from "../../assets/portfolio/tauku/tauku3.png";
import crm1 from "../../assets/portfolio/crm-sales/crm1.png";
import crm2 from "../../assets/portfolio/crm-sales/crm2.png";
import crm3 from "../../assets/portfolio/crm-sales/crm3.png";
import smp1 from "../../assets/portfolio/smp/smp1.png";
import smp2 from "../../assets/portfolio/smp/smp2.png";
import smp3 from "../../assets/portfolio/smp/smp3.png";
// import dmnew1 from "../../assets/portfolio/dmnew/dmnew1.png";
// import dmnew2 from "../../assets/portfolio/dmnew/dmnew2.png";
// import dmnew3 from "../../assets/portfolio/dmnew/dmnew3.png";
import cerdaspajak1 from "../../assets/portfolio/cerdaspajak/cerdaspajak1.png";
import cerdaspajak2 from "../../assets/portfolio/cerdaspajak/cerdaspajak2.png";
import cerdaspajak3 from "../../assets/portfolio/cerdaspajak/cerdaspajak3.png";
import nico1 from "../../assets/portfolio/nico/nico1.png";
import nico2 from "../../assets/portfolio/nico/nico2.png";
import nico3 from "../../assets/portfolio/nico/nico3.png";

export const data = [
  {
    id: 0,
    image: [ms1, ms2, ms3],
    title: "MasterStudio",
    description: "Landing Page Jasa Fotografi",
    tools: "Nuxt 4, Tailwind, Typescript",
    demo: "https://masterstudio-idn.com/",
  },
  {
    id: 1,
    image: [aa1, aa2, aa3],
    title: "Asihangger",
    description: "Landing Page Jasa Fotografi",
    tools: "Nuxt 4, Tailwind, Typescript",
    demo: "https://asihanggerfotografi.com/",
  },
  {
    id: 2,
    image: [crm1, crm2, crm3],
    title: "CRM Sales",
    description: "Aplikasi website CRM Sales",
    tools: "Nuxt 3, Tailwind, Pinia, Axios, Typescript",
    demo: "",
  },
  {
    id: 3,
    image: [cerdaspajak1, cerdaspajak2, cerdaspajak3],
    title: "Cerdas Pajak",
    description: "Aplikasi Pembelajaran Pajak Online",
    tools: "Laravel, Tailwind, Javascript, Ajax",
    demo: "https://www.cerdaspajak.com/",
  },
  {
    id: 4,
    image: [smp1, smp2, smp3],
    title: "SMPIPK Muhammadiyah Delanggu",
    description: "Aplikasi website sekolah",
    tools: "Wordpress",
    demo: "https://smpipkmuhammadiyahdelanggu.sch.id/",
  },
  {
    id: 5,
    image: [nico1, nico2, nico3],
    title: "Nicofaart",
    description: "Landing Page Jasa Furniture Jepara",
    tools: "Nuxt 3, Tailwind, Pinia, Typescript",
    demo: "https://nicofaart.com/",
  },
  {
    id: 6,
    image: [tauku1, tauku2, tauku3],
    title: "Tauku",
    description: "Website merchant toko online",
    tools: "Nuxt 3, Tailwind, Pinia, Axios, Typescript",
    demo: "https://my.tauku.com/login",
  },
  {
    id: 7,
    image: [profilhwi1, profilhwi2, profilhwi3],
    title: "Profile Health Wealth International",
    description: "Website company profile HWI",
    tools: "Vue JS, Bootstrap Vue, Vuex, Sass",
    demo: "https://www.healthwealthint.com/",
  },
  {
    id: 8,
    image: [hwi1, hwi2, hwi3, hwi4],
    title: "MLM Distributor Health Wealth International",
    description: "Website MLM HWI (Health Wealth International)",
    tools: "Vue JS, Element UI, Vuex, Sass",
    demo: "https://member.healthwealthint.com/#/login",
  },
  {
    id: 9,
    image: [adminPasaroa1, adminPasaroa2, adminPasaroa3],
    title: "MLM Pasaroa Admin",
    description: "Website MLM Pasaroa",
    tools: "Vue JS, Element UI, Vuex, Sass",
    demo: "https://demo-accounts.pasaroa.com/#/login",
  },
  {
    id: 10,
    image: [memberPasaroa1, memberPasaroa2, memberPasaroa3],
    title: "MLM Pasaroa Member",
    description: "Website MLM Pasaroa",
    tools: "Vue JS, Element UI, Vuex, Sass",
    demo: "https://demo-adminmlm20.pasaroa.com/#/login",
  },
  {
    id: 11,
    image: [bumaA1, bumaA2, bumaA3],
    title: "MLM Buma Admin",
    description: "Website MLM Bebek Buma",
    tools: "Vue JS, Element UI, Vuex, Sass",
  },
  {
    id: 12,
    image: [bumaM1, bumaM2, bumaM3],
    title: "MLM Buma Member",
    description: "Website MLM Bebek Buma",
    tools: "Vue JS, Element UI, Vuex, Sass",
  },
  {
    id: 13,
    image: [superbuma1, superbuma2, superbuma3],
    title: "Company Profile MLM Bebek Buma",
    description: "Website company profile bebek buma",
    tools: "Bootstrap, CSS, Javascript",
    demo: "https://www.inolabs.net/template/bumafront/index.html",
  },
  {
    id: 14,
    image: [admin1, admin2, admin3],
    title: "MLM Foreman Admin",
    description: "Website MLM Foreman",
    tools: "Vue JS, Element UI, Vuex, Sass",
  },
  {
    id: 15,
    image: [member1, member2, member3],
    title: "MLM Foreman Member",
    description: "Website MLM Foreman",
    tools: "Vue JS, Element UI, Vuex, Sass",
  },
  {
    id: 16,
    image: [adachat1, adachat2, adachat3],
    title: "Ada-Chat",
    github: "https://github.com/AdiPrimanto/ada-chat",
    demo: "https://ada-chat.vercel.app/",
    description: "Website chat",
    tools: "Vue JS, Tailwind, Pinia",
  },
  {
    id: 17,
    image: [omnimata1, omnimata2, omnimata3],
    title: "Omnimata",
    demo: "https://omnimata.transisi.space/omnimata/#/login",
    description: "Website tracking inventory coal supply chain",
    tools: "Vue JS, Tailwind, Vuex",
  },
  {
    id: 18,
    image: [momofin1],
    title: "Momofin",
    demo: "https://app.momofin.com/registration",
    description: "Website beli e-meterai",
    tools: "Vue JS, Vuetify, Vuex",
  },
  {
    id: 19,
    image: [adago1, adago2, adago3],
    title: "Adago",
    demo: "https://transisi.space/adago-html/index.php",
    description: "Website adago PT Adaro",
    tools: "PHP, Bootstrap, Javascript, Sass, Jquery",
  },
  {
    id: 20,
    image: [webflix1, webflix2, webflix3],
    title: "Weebflix",
    github: "https://github.com/AdiPrimanto/webflix",
    demo: "https://webflix-rose.vercel.app/",
    description: "Website clone netflix",
    tools: "Vue JS, Tailwind, Sass, Vuex",
  },
  {
    id: 21,
    image: [tokoonline1, tokoonline2, tokoonline3],
    title: "Shayna Store",
    github: "https://github.com/AdiPrimanto/shayna-store",
    description: "Website toko online",
    tools: "Vue JS, Bootstrap",
  },
  {
    id: 22,
    image: [portfolio1, portfolio2, portfolio3],
    title: "Portfolio Vue",
    github: "https://github.com/AdiPrimanto/Portofolio",
    demo: "https://portofolio-adiprimanto.vercel.app/",
    description: "Website portofolio",
    tools: "Vue JS, Sass",
  },
  {
    id: 23,
    image: [KiriminAJA1, KiriminAJA2, KiriminAJA3],
    title: "Company Profile KiriminAja",
    github: "https://github.com/AdiPrimanto/kirimin_aja",
    demo: "https://kirimin-aja-kappa.vercel.app/",
    description: "Website company profile KiriminAja",
    tools: "Nuxt JS, Tailwind, Sass, Vuex",
  },
  {
    id: 24,
    image: [emet1, emet2, emet3],
    title: "Landing Page e-Meterai",
    github: "https://github.com/AdiPrimanto/memet",
    demo: "https://memet-adiprimanto.vercel.app/",
    description: "Website landing page e-meterai",
    tools: "Next JS, Typescript, Tailwind",
  },
  {
    id: 25,
    image: [watchme1, watchme2, watchme3],
    title: "WatchMe",
    github: "https://github.com/AdiPrimanto/watchme",
    demo: "https://watchme-five.vercel.app/",
    description: "Website list movie",
    tools: "Next JS, Tailwind",
  },
  {
    id: 26,
    image: [topupgame1, topupgame2, topupgame3],
    title: "Topup Game Voucher",
    github: "https://github.com/AdiPrimanto/topup-voucher-game",
    demo: "https://topup-voucher-game.vercel.app/",
    description: "Website topup game voucher",
    tools: "Next JS, Tailwind",
  },
  {
    id: 27,
    image: [d2c1, d2c2, d2c3],
    title: "D2C Gaming Store",
    demo: "https://d2cgamingstore.com/",
    description: "Website platform topup game",
    tools: "PHP, Bootstrap, Javascript, Jquery, CSS",
  },
  {
    id: 28,
    image: [d2c_v2_1, d2c_v2_2, d2c_v2_3],
    title: "D2C Gaming Store v2",
    demo: "http://demo.hjcorp.id/",
    description: "Website platform topup game versi 2",
    tools: "PHP, Bootstrap, Javascript, Jquery, CSS",
  },
  {
    id: 29,
    image: [lazcoal1, lazcoal2, lazcoal3],
    title: "Laz Coal Mandiri",
    demo: "https://lazcoalmandiri.co.id/",
    description: "Website company profile Laz Coal Mandiri",
    tools: "PHP, Bootstrap, Javascript",
  },
  {
    id: 30,
    image: [kinerjadosen1, kinerjadosen2, kinerjadosen3],
    title: "Kinerja Akademik Dosen",
    // github: "https://github.com/AdiPrimanto/sistemfuzzy",
    demo: "http://kinerjaakademikdosen.herokuapp.com/",
    description: "Aplikasi penilaian kinerja akademik dosen STMIK AKAKOM",
    tools: "PHP, Laravel, Bootstrap, Javascript",
  },
  // {
  //   id: 24,
  //   image: [hefa1, hefa2, hefa3],
  //   title: "Hefa Store",
  //   github: "https://github.com/AdiPrimanto/hefa-store",
  //   demo: "https://heefa-store.netlify.app/",
  //   description: "Website toko online",
  //   tools: "Bootstrap, Javascript",
  // },
];
